import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Spin } from 'antd';
import { useLangContext } from 'components/shared/Lang';
import { useAuthContext } from 'components/shared/Auth';
import { forgotPasswordPath } from 'constants/path';
import Link from 'components/shared/elements/Link';
import css from 'components/ant/css/auth.module.css';
import styles from 'components/ant/css/styles.module.css';
import { useCookies } from 'react-cookie';

const SignIn = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { signIn, resendVerifyEmail } = useAuthContext();
  const { t } = useLangContext();
  const [progress, setProgress] = useState(false);
    const [cookie, setCookie, removeCookie] = useCookies(['accessToken']);

  const onSubmit = ({ email, password }) => {
    setError(false);
      fetch(`/api/auth/sign-in`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              email,
              password
          })
      })
          .then((response) => {
              return response.json();
          })
          .then((data) => {
              console.log(data)
              setProgress(false);
              if (data.status == 'success') {
                  setCookie('accessToken', data.token, { path: '/' });
                  window.location.href = '/';
                  setError(null);
              } else {
                  setError(data.error);
              }


          })
          .catch((error) => {
              setProgress(false);
              setError('Не удалось войти. Проверьте подключение к интернету.');

          });
  };

  const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };
  const tailLayout = {
    wrapperCol: { offset: 0, span: 24 },
  };

  const onFinish = (values) => {
    onSubmit(values);
  };

  const onFinishFailed = (errorInfo) => {
    //console.log('Failed:', errorInfo);
  };

  const onValuesChange = (value) => {
    setError(false);
  };

  const inputCss = {
    padding: '6px 14px',

    position: 'static',
    width: '100%',

    background: '#F0F0F0',
    border: '1px solid #D9D9D9',
    boxSizing: 'border-box',
    borderRadius: '5px',

    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.75)',
  };

  const smb = {
    width: '100%',
    height: '38px',
    background: '#003A8C',
    boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.043)',
    borderRadius: '6px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '22px',
    textAlign: 'center',
    color: '#FFFFFF',
  };

  return (
    <div className={css.row}>
      <Row justify={'center'}>
        <Col span={10} className={styles.line}>
          <Link href='/'>
            <svg width='100' height='20' viewBox='0 0 100 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <g clipPath='url(#clip0)'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M36.874 8.44032C36.972 15.1893 37.113 17.0462 37.5775 17.7076C38.4941 19.0112 41.011 19.9663 43.531 19.9663H45.7535L45.6362 18.0605L45.5192 16.1546L43.7836 16.0388C42.8287 15.9753 41.8265 15.7509 41.5561 15.5407C41.2191 15.2786 41.0641 14.0276 41.0641 11.5725V7.98654H42.5862C44.0877 7.98654 45.3309 7.27356 45.32 6.41791C45.3173 6.18231 45.2096 5.62252 45.0814 5.1731C44.8796 4.46738 44.5902 4.35629 42.9558 4.35629H41.0641V2.17815V0H38.9078H36.7512L36.874 8.44032ZM24.406 3.97911C22.7429 4.2826 20.9446 5.14261 20.0618 6.0567C18.0341 8.15607 17.4244 13.4802 18.9019 16.1807C20.4259 18.9662 22.3908 20.0255 26.0494 20.0339C27.7299 20.0379 28.6775 19.8171 29.9272 19.1307C30.8972 18.5981 31.9517 17.6045 32.4774 16.7282C34.3695 13.5735 33.9124 8.64579 31.495 6.13838C29.7618 4.34068 27.014 3.50355 24.406 3.97911ZM72.7528 3.98928C70.6911 4.34431 68.4171 5.88753 67.5783 7.50045C67.1309 8.36118 66.7966 9.95268 66.704 11.6636C66.5858 13.8545 66.7148 14.7729 67.3223 16.0591C67.7445 16.9536 68.694 18.1171 69.4324 18.6449C70.9991 19.7649 73.7565 20.3406 75.8276 19.9798C80.0816 19.2388 82.1282 16.5772 82.1282 11.7856C82.1282 10.0151 81.8934 9.1003 81.0516 7.59048C80.216 6.09191 79.5869 5.48022 78.243 4.86017C76.1553 3.89671 74.6638 3.66038 72.7528 3.98928ZM91.1449 3.98383C88.4052 4.59153 86.2706 6.77767 85.6136 9.64883C85.3862 10.6417 85.2498 13.3284 85.3107 15.6195L85.4211 19.7848L87.4549 19.8945L89.4887 20.0045V15.283C89.4887 12.5962 89.6739 10.1807 89.9188 9.67715C90.3441 8.80262 91.726 7.98654 92.7816 7.98654C93.8373 7.98654 95.2191 8.80262 95.6445 9.67715C95.8889 10.1803 96.0745 12.5911 96.0745 15.2641V19.9663H98.2052H100.336L100.327 15.5193C100.316 10.5237 99.9097 8.34121 98.6755 6.64444C97.1631 4.56576 93.8295 3.38811 91.1449 3.98383ZM0.258394 4.59843C-0.16968 4.99957 -0.032154 6.72212 0.464877 7.18788C0.766659 7.47068 2.33988 7.62351 4.95171 7.62351H8.97367L4.48761 12.0706C0.0608212 16.4588 0.00154953 16.5405 0.000774738 18.242L0 19.9663H6.99872C11.0823 19.9663 14.3093 19.8099 14.7467 19.5906C15.7574 19.0835 15.7574 17.219 14.7467 16.7118C14.3345 16.5053 12.1356 16.3361 9.86042 16.3361H5.72379L10.0286 12.0234C14.2252 7.81955 14.3337 7.66853 14.3337 6.03347V4.35629H7.42524C3.62526 4.35629 0.400181 4.4652 0.258394 4.59843ZM48.9647 4.87034C48.8488 5.15277 48.8109 5.84724 48.8798 6.41319L49.0057 7.442L53.1993 7.62351L57.3933 7.80503L53.1025 12.0372L48.812 16.2697V18.1178V19.9663H55.9014C60.8988 19.9663 63.1279 19.8378 63.4557 19.5307C64.0743 18.951 64.0484 17.2506 63.4134 16.7565C63.1341 16.5398 61.0275 16.3154 58.7313 16.2584L54.5564 16.1546L58.8511 11.8466C62.9668 7.71826 63.1457 7.4725 63.1457 5.94743V4.35629H56.1606C50.4937 4.35629 49.1355 4.45322 48.9647 4.87034ZM28.2703 8.34049C28.691 8.73473 29.1478 9.47712 29.2853 9.9908C29.7037 11.5533 29.2458 14.8107 28.4989 15.5839C27.5827 16.5329 25.7716 16.8661 24.4076 16.3368C21.8039 15.3262 21.2848 10.5785 23.5247 8.25953C24.4018 7.35088 27.2666 7.39989 28.2703 8.34049ZM76.681 8.25881C78.465 9.61253 78.4948 14.0941 76.731 15.7469C75.6815 16.73 73.2064 16.7674 72.0853 15.8163C70.2932 14.2966 70.1906 10.0645 71.9067 8.45629C73.0062 7.42603 75.4506 7.32475 76.681 8.25881Z'
                  fill='#0C6091'
                />
              </g>
              <defs>
                <clipPath id='clip0'>
                  <rect width='100' height='20' fill='white' />
                </clipPath>
              </defs>
            </svg>
          </Link>
        </Col>
      </Row>
      <Form
        {...layout}
        name='basic'
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row justify={'center'}>
          <Col span={24}>
            <Form.Item label={false} name='email' rules={[{ required: true, message: t('pleaseInputYourUsername') }]}>
              <Input style={inputCss} placeholder={t('email') + ' *'} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={'center'}>
          <Col span={24}>
            <Form.Item
              label={false}
              name='password'
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password style={inputCss} placeholder={t('password')} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={14} className={styles.formRow}>
            {error && <div>{error}</div>}
          </Col>
          <Col span={10} className={styles.rowCol}>
            <Link href={forgotPasswordPath()} className={styles.link}>
              {t('forgotPassword')}?
            </Link>
          </Col>
        </Row>
        <Row justify={'center'}>
          <Col span={24}>
            <Form.Item {...tailLayout}>
                {progress && <Spin />}
              <Button type='primary'
                      disabled={progress}
                      style={smb} htmlType='submit'>
                {t('toSignIn')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div className={styles.div}></div>
      <div className={styles.div1}>
        {t('haventAccount')} ?{' '}
        <Link href='/auth/sign-up' className={styles.link1}>
          {t('toSignUp')}.
        </Link>
      </div>

      {/*<FormBlock/>*/}
    </div>
  );
};

export default SignIn;
